// const HOST = 'http://0.0.0.0:8080';
const HOST = 'https://api2.grofers.com';

const BEAUTY_STORE_HOST = `${HOST}/beauty_store`;
const PROMO_HOST = `${BEAUTY_STORE_HOST}/promo`;

export const VERIFY_PROMO = `${PROMO_HOST}/fetch/get-voucher-info`;
export const REDEEM_PROMO = `${PROMO_HOST}/update/redeem-promo`;